import { useMemo } from 'react';
import getShareLink from '../utils/getShareLink';

/**
 * @temporary Check if any editor2 forms are still getting submissions from old style links (no subdomain), if not, just remove the date check and set useSubdomain to true always. Check PR https://git.hubteam.com/HubSpot/vis-exp-editor-forms/pull/1232 for athena query link
 * @expiration 2026-02-11
 * @deprecated
 */
const SUBDOMAIN_SHARE_LINK_RELEASE_DATE_UTC = 1747612800000; // April 19, 2025 00:00:00 UTC

const useShareLink = (formId, {
  version,
  createdAt = 0
} = {}) => {
  const shareLink = useMemo(() => getShareLink(formId, {
    version,
    useSubdomain: version === 2 && createdAt > SUBDOMAIN_SHARE_LINK_RELEASE_DATE_UTC
  }), [formId, version, createdAt]);
  return shareLink;
};
export default useShareLink;